// src/components/pages/EventManager/molecules/DateFields.js

import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import InputField from "../atoms/InputField";

const DateFields = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  required = true,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" }, // Responsive layout
        gap: 2,
      }}
    >
      <InputField
        label="Start Date"
        type="date"
        value={startDate}
        onChange={onStartChange}
        required={required}
      />
      <InputField
        label="End Date"
        type="date"
        value={endDate}
        onChange={onEndChange}
        required={required}
      />
    </Box>
  );
};

DateFields.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onStartChange: PropTypes.func.isRequired,
  onEndChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

export default DateFields;
